import { render, staticRenderFns } from "./btn-check.vue?vue&type=template&id=db116d6e&scoped=true"
import script from "./btn-check.vue?vue&type=script&lang=ts"
export * from "./btn-check.vue?vue&type=script&lang=ts"
import style0 from "./btn-check.vue?vue&type=style&index=0&id=db116d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db116d6e",
  null
  
)

export default component.exports